import React, { useState, useEffect } from "react";
import {
    TextField,
    MenuItem,
    Select,
    FormControl,
    Button,
    Box,
    Grid,
    Stepper,
    Step,
    StepLabel,
    Chip,
} from "@mui/material";
import axios from "axios";
import LanguageSelector from "./LanguageSelector";
import CircularProgress from "@mui/material/CircularProgress";
import "../shared/modern-ui.css";

const UpdateUserDetailsForm = () => {
    const [formValues, setFormValues] = useState({
        residence_city: "",
        education_status: "",
        highschool: "",
        undergraduate: "",
        masters: "",
        phd: "",
        job_status: "",
        category_of_interest: [],
        position_tags: "",
        competency_tags: "",
        languages: [],
        driver_license_status: "",
        military_status: "",
        profile_link1: "",
        profile_link2: "",
        cv_english: null,
        cv_turkish: null,
        profile_image: null,
    });

    const [activeStep, setActiveStep] = useState(0);
    const [loading, setLoading] = useState(false);
    const steps = ["Eğitim", "Kişisel bilgiler", "Dökümanlar"];
    const cities = [
        "Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya", "Ankara", "Antalya",
        "Ardahan", "Artvin", "Aydın", "Balıkesir", "Bartın", "Batman", "Bayburt", "Bilecik", "Bingöl",
        "Bitlis", "Bolu", "Burdur", "Bursa", "Çanakkale", "Çankırı", "Çorum", "Denizli", "Diyarbakır",
        "Düzce", "Edirne", "Elazığ", "Erzincan", "Erzurum", "Eskişehir", "Gaziantep", "Giresun",
        "Gümüşhane", "Hakkari", "Hatay", "Iğdır", "Isparta", "İstanbul", "İzmir", "Kahramanmaraş",
        "Karabük", "Karaman", "Kars", "Kastamonu", "Kayseri", "Kırıkkale", "Kırklareli", "Kırşehir",
        "Kilis", "Kocaeli", "Konya", "Kütahya", "Malatya", "Manisa", "Mardin", "Mersin", "Muğla",
        "Muş", "Nevşehir", "Niğde", "Ordu", "Osmaniye", "Rize", "Sakarya", "Samsun", "Siirt",
        "Sinop", "Sivas", "Şanlıurfa", "Şırnak", "Tekirdağ", "Tokat", "Trabzon", "Tunceli",
        "Uşak", "Van", "Yalova", "Yozgat", "Zonguldak"
    ];
    const categories = [
        "Araştırma Geliştirme (AR-GE)",
        "Geri Ödeme/Pazara Erişim",
        "Klinik Destek/Aplikasyon",
        "Kalite/Belgelendirme/Mevzuat",
        "Lojistik ve Tedarik Zinciri",
        "Pazarlama/Ürün Yönetimi",
        "Satış",
        "Teknik Servis",
        "Teknoloji Yönetimi",
        "Test/Kalibrasyon/Muayene",
        "Üretim",
        "Diğer"
    ];
    const lisans = [
        "Acıbadem Mehmet Ali Aydınlar Üniversitesi - Biyomedikal Mühendisliği",
        "Afyon Kocatepe Üniversitesi - Biyomedikal Mühendisliği",
        "Ankara Üniversitesi - Biyomedikal Mühendisliği",
        "Bahçeşehir Üniversitesi - Biyomedikal Mühendisliği",
        "Başkent Üniversitesi - Biyomedikal Mühendisliği",
        "Beykent Üniversitesi - Biyomedikal Mühendisliği",
        "Biruni Üniversitesi - Biyomedikal Mühendisliği",
        "Çukurova Üniversitesi - Biyomedikal Mühendisliği",
        "Doğu Akdeniz Üniversitesi - Biyomedikal Mühendisliği",
        "Düzce Üniversitesi - Biyomedikal Mühendisliği",
        "Erciyes Üniversitesi - Biyomedikal Mühendisliği",
        "Fatih Sultan Mehmet Vakıf Üniversitesi - Biyomedikal Mühendisliği",
        "Işık Üniversitesi - Biyomedikal Mühendisliği",
        "İnönü Üniversitesi - Biyomedikal Mühendisliği",
        "İskenderun Teknik Üniversitesi - Biyomedikal Mühendisliği",
        "İstanbul Arel Üniversitesi - Biyomedikal Mühendisliği",
        "İstanbul Medipol Üniversitesi - Biyomedikal Mühendisliği",
        "İstanbul Yeni Yüzyıl Üniversitesi - Biyomedikal Mühendisliği",
        "İstinye Üniversitesi - Biyomedikal Mühendisliği",
        "İzmir Bakırçay Üniversitesi - Biyomedikal Mühendisliği",
        "İzmir Demokrasi Üniversitesi - Biyomedikal Mühendisliği",
        "İzmir Ekonomi Üniversitesi - Biyomedikal Mühendisliği",
        "İzmir Katip Çelebi Üniversitesi - Biyomedikal Mühendisliği",
        "Karabük Üniversitesi - Biyomedikal Mühendisliği",
        "Kastamonu Üniversitesi - Biyomedikal Mühendisliği",
        "Kocaeli Üniversitesi - Biyomedikal Mühendisliği",
        "Kocaeli Üniversitesi (M.T.O.K) - Biyomedikal Mühendisliği",
        "Pamukkale Üniversitesi - Biyomedikal Mühendisliği",
        "Samsun Üniversitesi - Biyomedikal Mühendisliği",
        "Tekirdağ Namık Kemal Üniversitesi - Biyomedikal Mühendisliği",
        "TOBB Ekonomi Ve Teknoloji Üniversitesi - Biyomedikal Mühendisliği",
        "Uluslararası Kıbrıs Üniversitesi - Biyomedikal Mühendisliği",
        "Yakın Doğu Üniversitesi - Biyomedikal Mühendisliği",
        "Yeditepe Üniversitesi - Biyomedikal Mühendisliği",
        "Yıldız Teknik Üniversitesi - Biyomedikal Mühendisliği",
        "Zonguldak Bülent Ecevit Üniversitesi - Biyomedikal Mühendisliği"
    ];

    // Fetch existing user details on component mount
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get("https://kariyer.biyomed.net/api/users/getOneDetails", {
                    withCredentials: true,
                });
                console.log(response.data)
                setFormValues(response.data.user);
                setFormValues((prev) => ({
                    ...prev,
                    category_of_interest: prev.category_of_interest.split(",") // Virgülleri kullanarak stringi diziye çeviriyoruz
                }));
            } catch (error) {
                console.error("Error fetching user details:", error);
            }
        };
        fetchData();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prev) => ({ ...prev, [name]: value }));
    };

    const handleNext = () => {
        if (activeStep < steps.length - 1) {
            setActiveStep((prevStep) => prevStep + 1);
        }
    };



    const handleBack = () => {
        setActiveStep((prevStep) => prevStep - 1);
    };

    const handleDocumentChange = (e, type) => {
        let file; // Seçilen dosya
        // Dosya seçilmediyse önceki değeri koru
        if (!e.target.files[0] && type === "profile_image") {
            file = formValues.profile_image; // Profil resmi için önceki değeri kullan
        } else if (!e.target.files[0] && type === "cv_english") {
            file = formValues.cv_english; // CV İngilizce için önceki değeri kullan
        } else if (!e.target.files[0] && type === "cv_turkish") {
            file = formValues.cv_turkish; // CV Türkçe için önceki değeri kullan
        } else {
            file = e.target.files[0]; // Yeni dosya seçildiyse bunu kullan
        }

        const maxSize = 5 * 1024 * 1024; // 5MB

        // Dosya boyut kontrolü
        if (file && file.size > maxSize) {
            alert("Dosya boyutu 5MB'ı geçemez!");
            e.target.value = ""; // Input'u temizle
            return;
        }

        // Geçerli dosya türlerini kontrol et
        const allowedTypes =
            type === "profile_image"
                ? ["image/jpeg", "image/png", "image/jpg"] // Profil resmi için izin verilen türler
                : ["application/pdf"]; // CV için izin verilen türler

        if (file && !allowedTypes.includes(file.type)) {
            alert("Geçersiz dosya türü!"); // Hata mesajı
            e.target.value = ""; // Input'u temizle
            return;
        }

        // Yeni dosya seçildiyse güncelle, seçilmediyse önceki değeri koru
        setFormValues((prev) => ({
            ...prev,
            [type]: file, // Dosya seçilmediyse önceki değeri kullan
        }));
    };

    const handleRemoveDocument = (field) => {
        setFormValues((prevValues) => ({
            ...prevValues,
            [field]: null,  // Dosyayı null yapıyoruz
        }));
    };

    const isValidUrl = (url) => {
        const regex = /^(https?:\/\/)?([a-z0-9.-]+)(\.[a-z]{2,})((\/[^\s]*)*)$/i;
        return regex.test(url);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        if (!formValues.residence_city || !formValues.education_status || !formValues.job_status ||
            !formValues.military_status || !formValues.driver_license_status || !formValues.languages) {
            alert("Lütfen tüm zorunlu (*) ile işaretlenmiş alanları doldurun!");
            setLoading(false)
            return;
        }
        if (
            !formValues.cv_english &&
            !formValues.cv_turkish &&
            !(
                (formValues.profile_link1 && formValues.profile_link1.includes("linkedin.com")) ||
                (formValues.profile_link2 && formValues.profile_link2.includes("linkedin.com"))
            )
        ) {
            alert("En az 1 CV veya LinkedIn linki eklemelisiniz!");
            setLoading(false)
            return
        }
        if (formValues.profile_link1 !== '') {
            if (!isValidUrl(formValues.profile_link1)) {
                alert("Geçerli bir link giriniz")
                setLoading(false)
                return
            }
        }
        if (formValues.profile_link2!== '') {
            if (!isValidUrl(formValues.profile_link2)) {
                alert("Geçerli bir link giriniz")
                setLoading(false)
                return
            }
        }

        const formData = new FormData();
        Object.entries(formValues).forEach(([key, value]) => {
            if (value instanceof File) {
                formData.append(key, value);
            } else {
                formData.append(key, value);
            }
        });

        try {
            const response = await axios.put(
                "https://kariyer.biyomed.net/api/user/updateUserDetails",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    withCredentials: true,
                }
            );
            console.log("Update Response:", response.data);
            setLoading(false)
            window.location.href = "/userprofile";
        } catch (err) {
            console.error("Error updating details:", err);
            setLoading(false)
        }
    };

    // Dosya yukleme kutusu - uc yerde ayni sekilde kullaniliyor
    const UploadBox = ({ field, label, accept, hint }) => {
        const value = formValues[field];
        return (
            <>
                <label className="bm-label">{label}</label>
                <div className={`bm-upload${value ? " bm-upload--filled" : ""}`}>
                    <span className="bm-upload-icon">
                        <i className={`fa ${value ? "fa-check" : "fa-cloud-upload"}`} />
                    </span>
                    <span className="bm-upload-text">
                        <span className="bm-upload-title">
                            {value ? "Belge yüklendi" : "Belge yükle"}
                        </span>
                        <span className="bm-upload-sub">
                            {value?.name ? value.name : hint}
                        </span>
                    </span>
                    <input
                        type="file"
                        name={field}
                        accept={accept}
                        onChange={(e) => handleDocumentChange(e, field)}
                    />
                </div>
                {value && (
                    <button
                        type="button"
                        className="bm-upload-remove"
                        onClick={() => handleRemoveDocument(field)}
                    >
                        <i className="fa fa-trash" /> Dosyayı Sil
                    </button>
                )}
            </>
        );
    };

    return (
        <div className="bm-page">
            <div className="bm-container">
                <div className="bm-page-head">
                    <h1 className="bm-page-title">Detay Bilgilerim</h1>
                    <p className="bm-page-sub">
                        Profilinizi tamamlayın — işverenler sizi bu bilgilerle bulur.
                    </p>
                </div>

                <div className="bm-card">
                    {/* Adımlar (Stepper) */}
                    <div className="bm-card-head" style={{ display: "block", padding: "24px" }}>
                        <Stepper activeStep={activeStep}>
                            {steps.map((label, index) => (
                                <Step key={index}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </div>

                    <Box component="form" className="bm-card-body">
                        {/* Form içerikleri */}
                        {activeStep === 0 && (
                            <Grid container spacing={2.5}>
                                <Grid item xs={12} sm={6}>
                                    <label className="bm-label">Eğitim durumu <span className="bm-req">*</span></label>
                                    <FormControl fullWidth size="small">
                                        <Select
                                            name="education_status"
                                            value={formValues.education_status}
                                            onChange={handleInputChange}
                                            displayEmpty
                                        >
                                            <MenuItem value="Lise">Lise</MenuItem>
                                            <MenuItem value="Lisans">Lisans</MenuItem>
                                            <MenuItem value="Yüksek Lisans">Yüksek Lisans</MenuItem>
                                            <MenuItem value="Doktora">Doktora</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Lise ve Lisans */}
                                <Grid item xs={12} sm={6}>
                                    <label className="bm-label">Lise (Lise-İl)</label>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="highschool"
                                        value={formValues.highschool}
                                        onChange={handleInputChange}
                                        disabled={formValues.education_status !== "Lise" && formValues.education_status !== "Lisans" && formValues.education_status !== "Yüksek Lisans" && formValues.education_status !== "Doktora"}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <label className="bm-label">Lisans</label>
                                    <Select
                                        fullWidth
                                        size="small"
                                        displayEmpty
                                        name="undergraduate"
                                        value={formValues.undergraduate}
                                        onChange={handleInputChange}
                                        disabled={
                                            formValues.education_status !== "Lisans" &&
                                            formValues.education_status !== "Yüksek Lisans" &&
                                            formValues.education_status !== "Doktora"
                                        }
                                    >
                                        {lisans.map((universite, index) => (
                                            <MenuItem key={index} value={universite}>
                                                {universite}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid>

                                {/* Yüksek Lisans ve Doktora */}
                                <Grid item xs={12} sm={6}>
                                    <label className="bm-label">Yüksek Lisans <span className="bm-hint" style={{ display: "inline" }}>(Üniversite-Enstitü-Ana Bilim Dalı)</span></label>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="masters"
                                        value={formValues.masters}
                                        onChange={handleInputChange}
                                        disabled={formValues.education_status !== "Yüksek Lisans" && formValues.education_status !== "Doktora"}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <label className="bm-label">Doktora <span className="bm-hint" style={{ display: "inline" }}>(Üniversite-Enstitü-Ana Bilim Dalı)</span></label>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="phd"
                                        value={formValues.phd}
                                        onChange={handleInputChange}
                                        disabled={formValues.education_status !== "Doktora"}
                                    />
                                </Grid>
                            </Grid>
                        )}


                        {activeStep === 1 && (
                            <Grid container spacing={2.5}>
                                <Grid item xs={12} sm={6}>
                                    <label className="bm-label">İl <span className="bm-req">*</span></label>
                                    <Select
                                        name="residence_city"
                                        size="small"
                                        displayEmpty
                                        value={formValues.residence_city}
                                        onChange={handleInputChange}
                                        style={{ width: "100%" }}
                                    >
                                        <MenuItem value="">İl Seçiniz</MenuItem>
                                        {cities.map((city, index) => (
                                            <MenuItem key={index} value={city}>
                                                {city}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <label className="bm-label">Çalışma durumu <span className="bm-req">*</span></label>
                                    <FormControl fullWidth size="small">
                                        <Select
                                            name="job_status"
                                            displayEmpty
                                            value={formValues.job_status || ""}
                                            onChange={handleInputChange}
                                        >
                                            <MenuItem value="Çalışıyor">Çalışıyor</MenuItem>
                                            <MenuItem value="Çalışmıyor">Çalışmıyor</MenuItem>
                                            <MenuItem value="Öğrenci">Öğrenci</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <label className="bm-label">Askerlik durumu <span className="bm-req">*</span></label>
                                    <FormControl fullWidth size="small">
                                        <Select
                                            name="military_status"
                                            displayEmpty
                                            value={formValues.military_status || ""}
                                            onChange={handleInputChange}
                                        >
                                            <MenuItem value="Yaptı">Yaptı</MenuItem>
                                            <MenuItem value="Tecilli">Tecilli</MenuItem>
                                            <MenuItem value="Muaf">Muaf</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <label className="bm-label">Çalıştığı / İlgilendiği Kategori <span className="bm-req">*</span></label>
                                    <FormControl fullWidth size="small">
                                        <Select
                                            name="category_of_interest"
                                            value={formValues.category_of_interest} // Virgülle ayrılmış stringi diziye çeviriyoruz
                                            onChange={handleInputChange}
                                            multiple // Çoklu seçim için
                                            displayEmpty
                                            renderValue={(selected) => (
                                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                                    {Array.isArray(selected) && selected.filter(Boolean).length > 0 ? (
                                                        selected.filter(Boolean).map((value) => (
                                                            <Chip key={value} label={value} size="small" />
                                                        ))
                                                    ) : (
                                                        // Eğer category_of_interest boşsa, burada alt alta bir liste gösterilebilir.
                                                        <Box sx={{ color: "#94a3b8" }}>Henüz bir kategori seçilmedi.</Box>
                                                    )}
                                                </Box>
                                            )}
                                        >
                                            {categories.map((category) => (
                                                <MenuItem key={category} value={category}>
                                                    {category}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <LanguageSelector formValues={formValues} setFormValues={setFormValues} />
                                    </FormControl>
                                </Grid>




                                <Grid item xs={12}>
                                    <label className="bm-label">Pozisyon Etiketleri</label>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="position_tags"
                                        value={formValues.position_tags}
                                        onChange={handleInputChange}
                                    />
                                    <span className="bm-hint">
                                        İlgilendiğiniz pozisyon adları — örnek: satış müdürü, üretim sorumlusu, mühendis
                                    </span>
                                </Grid>
                                <Grid item xs={12}>
                                    <label className="bm-label">Yetkinlik Etiketleri</label>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="competency_tags"
                                        value={formValues.competency_tags}
                                        onChange={handleInputChange}
                                    />
                                    <span className="bm-hint">
                                        Bilgi ve becerilerinizi tanımlar — örnek: iso13485, kalite kontrol, e-ihale, sağlık market
                                    </span>
                                </Grid>
                            </Grid>
                        )}

                        {activeStep === 2 && (
                            <Grid container spacing={2.5}>
                                <Grid item xs={12}>
                                    <div className="bm-note">
                                        <i className="fa fa-info-circle" style={{ marginTop: 2 }} />
                                        <span>
                                            En az bir CV yüklemeli ya da LinkedIn profil linkinizi girmelisiniz.
                                        </span>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <label className="bm-label">Profil Linki (LinkedIn vs.)</label>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="profile_link1"
                                        value={formValues.profile_link1}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <label className="bm-label">İlave portföy bağlantı linki</label>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="profile_link2"
                                        value={formValues.profile_link2}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <UploadBox
                                        field="cv_english"
                                        label="CV İngilizce"
                                        accept=".pdf"
                                        hint="PDF · en fazla 5MB"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <UploadBox
                                        field="cv_turkish"
                                        label="CV Türkçe"
                                        accept=".pdf"
                                        hint="PDF · en fazla 5MB"
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <UploadBox
                                        field="profile_image"
                                        label="Profil Resmi"
                                        accept=".jpg,.jpeg,.png"
                                        hint="JPG veya PNG · en fazla 5MB"
                                    />
                                </Grid>

                            </Grid>
                        )}
                    </Box>

                    {/* Butonlar */}
                    <div className="bm-form-footer">
                        <Button
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            variant="outlined"
                            sx={{ textTransform: "none", borderRadius: "10px", px: 2.5, fontWeight: 600 }}
                        >
                            Geri
                        </Button>
                        {activeStep < steps.length - 1 ? (
                            <Button
                                onClick={handleNext}
                                variant="contained"
                                sx={{ textTransform: "none", borderRadius: "10px", px: 3, fontWeight: 600 }}
                            >
                                İleri
                            </Button>
                        ) : (
                            <Button
                                onClick={handleSubmit}
                                variant="contained"
                                color="primary"
                                disabled={loading}
                                sx={{ textTransform: "none", borderRadius: "10px", px: 3, fontWeight: 600 }}
                            >
                                {loading ? <CircularProgress size={22} color="inherit" /> : "Kaydet"}
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );

};

export default UpdateUserDetailsForm;
